var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 35,
    viewBox: "0 0 140 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 23.3664C1.3335 23.3664 6.74577 22.5734 12.8992 24.4785C24.6027 28.1018 25.2703 21.4666 29.6101 18.2672C33.5805 15.3401 36.8688 17.126 41.2895 20.7056C44.55 23.3457 49.3018 27.7774 54.2228 27.064C58.7211 26.4118 61.91 21.214 68.1451 19.8922C73.0868 18.8445 77.1027 21.7227 82.7931 20.7056C90.5126 19.3258 93.9608 11.2029 99.478 11.2029C106.287 11.2029 111.081 4.33276 117.276 4.33276C123.434 4.33276 124.27 8.37256 131.006 11.2029C136.156 13.3667 138.634 11.2029 138.634 11.2029V34.3896H1.3335V23.3664Z",
    fill: "url(#paint0_linear_1_6881)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 19.7649C1.3335 19.7649 6.74577 18.9834 12.8992 20.8609C24.6027 24.4319 25.2703 17.8926 29.6101 14.7396C33.5805 11.8548 36.8688 13.6149 41.2895 17.1427C44.55 19.7446 49.3018 24.1121 54.2228 23.409C58.7211 22.7663 61.91 17.6438 68.1451 16.341C73.0868 15.3085 77.1027 18.1451 82.7931 17.1427C90.5127 15.7829 93.9608 7.77751 99.4779 7.77751C106.287 7.77751 111.081 0.990479 117.276 0.990479C123.434 0.990479 123.762 4.98816 130.498 7.77751C135.648 9.90999 138.634 7.77751 138.634 7.77751",
    stroke: "#F7801A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_6881",
    x1: 26.1473,
    y1: 19.5837,
    x2: 26.1473,
    y2: 34.3896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7801A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.649b1803f31bf278778b0329220618f9.svg";
export { ForwardRef as ReactComponent };